export default {
  LIST_TYPE_BULLET_TAG: 'UL',
  LIST_TYPE_NUMBER_TAG: 'OL',
  LIST_ITEM_TAG: 'LI',
  SUPPORTED_TAGS: ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
  BLOCK_ELEMENT_TAGS: ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote', 'address', 'dl'],
};
